import {  GenderValue, } from './gender-component.domain';
import {  PersonalAssetsValue, } from './personal-assets-component.domain';
import {  PersonalLiabilitiesValue, } from './personal-liabilities-component.domain';
import {  PropertyOwnerWithAddressValue, } from './property-owner-with-address-component.domain';
import {  TitleSelectionValue, } from './title-selection-component.domain';
import {  YesNoValue } from './yes-no-component.domain';
import { Address2ComponentValue } from './address2-component.domain';
import { CountryOfCitizenshipValue } from './individual-form-component.domain';
import { IdentificationComponentValue } from './identification-component.domain';
import { UploadFileValue } from './file-upload-component.domain';

import {Moment} from 'moment';



export type DirectorValueWithPropertyOwnerAddress = {
  kind: 'Director',
  type: 'WithPropertyAddress',
  // The saved individual a reopened draft prefilled this from; unset for a person typed in.
  guid?: string,
  title: TitleSelectionValue;
  firstName: string;
  middleName: string;
  lastName: string;
  dob: Moment,
  // no longer collected by the unified individual-form; kept optional for historical values
  gender?: GenderValue,
  residentialAddress: Address2ComponentValue,
  propertyOwner: PropertyOwnerWithAddressValue,
  // propertyValue: number,
  // mortgageBalance: number,
  // no longer collected per person; guarantor selection happens on the KYB Key People screen
  guarantor?: YesNoValue,
  hasAlias?: boolean,
  aliasNames?: string | null,
  countryOfCitizenship?: CountryOfCitizenshipValue,
  identification?: IdentificationComponentValue,
  idDocument?: UploadFileValue,
  email: string,
  mobileNumber: string,
  personalAssets: PersonalAssetsValue,
  personalLiabilities: PersonalLiabilitiesValue,
  roleType?: string,
};


export type DirectorValueWithoutPropertyOwnerAddress = {
  kind: 'Director',
  type: 'WithoutPropertyAddress',
  // The saved individual a reopened draft prefilled this from; unset for a person typed in.
  guid?: string,
  title: TitleSelectionValue;
  firstName: string;
  middleName: string;
  lastName: string;
  dob: Moment,
  // no longer collected by the unified individual-form; kept optional for historical values
  gender?: GenderValue,
  residentialAddress: Address2ComponentValue,
  propertyOwner: YesNoValue,
  // propertyValue: number,
  // mortgageBalance: number,
  // no longer collected per person; guarantor selection happens on the KYB Key People screen
  guarantor?: YesNoValue,
  hasAlias?: boolean,
  aliasNames?: string | null,
  countryOfCitizenship?: CountryOfCitizenshipValue,
  identification?: IdentificationComponentValue,
  idDocument?: UploadFileValue,
  email: string,
  mobileNumber: string,
  personalAssets: PersonalAssetsValue,
  personalLiabilities: PersonalLiabilitiesValue,
  roleType?: string,
};

export type DirectorValue =  (IndividualDirector)[] | null;
export type IndividualDirector =  DirectorValueWithPropertyOwnerAddress | DirectorValueWithoutPropertyOwnerAddress;

